import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function PinIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.564 10.436 2 14m5.654-9.218-.983.984c-.08.08-.12.12-.166.152a.6.6 0 0 1-.13.07c-.053.02-.108.03-.22.053l-2.308.462c-.6.12-.9.18-1.04.338a.63.63 0 0 0-.153.505c.029.21.245.425.678.858l4.464 4.464c.433.433.649.65.858.678a.63.63 0 0 0 .505-.153c.158-.14.218-.44.338-1.04l.462-2.309c.022-.11.033-.166.053-.218a.6.6 0 0 1 .07-.13c.032-.046.072-.086.152-.167l.984-.983c.051-.051.077-.077.105-.1a1 1 0 0 1 .08-.053c.03-.018.064-.032.13-.06l1.572-.674c.458-.197.688-.295.792-.454a.63.63 0 0 0 .09-.47c-.037-.186-.214-.363-.566-.715l-3.24-3.24c-.353-.353-.53-.53-.716-.567a.63.63 0 0 0-.47.09c-.16.104-.257.334-.454.792l-.673 1.571c-.029.067-.043.1-.061.132a1 1 0 0 1-.054.08 1 1 0 0 1-.099.104" /></svg>
  );
}

export default PinIcon;
